import { render } from "./ViewDocumentClickSignComponent.vue?vue&type=template&id=0b32f91c&scoped=true"
import script from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"
export * from "./ViewDocumentClickSignComponent.vue?vue&type=script&lang=js"

import "./ViewDocumentClickSignComponent.vue?vue&type=style&index=0&id=0b32f91c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b32f91c"]])

export default __exports__